import React from "react"
import { getSubmenuComponent } from "./utils"
import { getSubmenuData } from "data/submenus"
// import "styles/submenu.sass"

export const Submenu = ({ page, has_sticky_submenu }) => {
  const submenu_content = getSubmenuData[page](1025)
    ?.map((item, index) => (item = { ...item, react_key: index }))
    ?.map(getSubmenuComponent)
  const submenu_content_mobile = getSubmenuData[page](900)
    ?.map((item, index) => (item = { ...item, react_key: index }))
    ?.map(getSubmenuComponent)

  return (
    <div
      data-nosnippet
      style={{
        zIndex: 350,
        width: "100%",
        height: 80,
        display: "flex",
      }}
      page={page}
      id="submenu"
      className={`submenu${has_sticky_submenu ? " submenu-sticky" : ""}`}
    >
      <div className="container is-flex is-justify-content-space-between is-hidden-touch">
        {submenu_content}
      </div>
      <div className="container is-flex is-justify-content-space-between is-hidden-desktop px-3-mobile">
        {submenu_content_mobile}
      </div>
    </div>
  )
}
